<template>
    <el-row class="card-container" :gutter="20">
      <el-col :xs="24" :sm="12" :md="12" :lg="12" v-for="member in data.members" :key="member._id">
        <el-card class="box-card member-card d-flex flex-column" shadow="never">
          <div class="flex-1 d-flex">
            <div class="member-avatar flex-0 d-flex align-items-center">
              <el-avatar class="d-flex flex-center fs-25" icon="el-icon-user-solid" :size="65"></el-avatar>
            </div>
            <div class="member-info flex-1 d-flex flex-column">
              <div class="name">{{ member.profile.firstName }} {{ member.profile.lastName }}</div>
              <div class="description">
                <div><span class="fw-bold">ID:</span> {{ member._id }}</div>
                <div><span class="fw-bold">Date of Birth:</span> {{ formatBirthdate(member.profile.dob, true) }}</div>
                <div><span class="fw-bold">Gender:</span> {{ member.profile.gender }}</div>
                <div v-if="member.profile.mobile"><span class="fw-bold">Mobile:</span> {{ member.profile.mobile }}</div>
                <div v-if="member.profile.email"><span class="fw-bold">Email:</span> {{ member.profile.email }}</div>
                <div v-if="nationalId === 4"><span class="fw-bold">Parent's Email:</span> {{ get(member, 'profile.meta.parentOrGuardian1.email', '-') }}</div>
              </div>
            </div>
          </div>
          <div class="member-btn d-flex justify-content-center flex-0">
            <el-button type="primary" class="bg-highlight bd-0 w-100" @click="selectMember(member)">Register This Member</el-button>
          </div>
        </el-card>
      </el-col>
      <el-col :xs="24" :sm="12" :md="12" :lg="12">
        <el-card class="box-card member-add pointer bds-dash" shadow="never" @click.native="addMember">
          <div class="op-5"><img src="~@/assets/icons/add-member.svg"></div>
          <div class="mt-10 c-lightblack op-5 text-center break-word">None of these profiles are mine, continue as a new member</div>
        </el-card>
      </el-col>
    </el-row>
</template>

<script>
import _ from 'lodash';
import { parseBirthdate } from '@/utils/form-helpers';

export default {
  name: 'LinkMember',
  props: {
    data: Object // { members, newMember }
  },
  data() {
    return {
      nationalId: +process.env.VUE_APP_NATIONAL_ID
    };
  },
  methods: {
    cancel() {
      this.$emit('updateVisible', false);
    },
    selectMember(member) {
      // emit member to parent
      this.$emit('selectMember', member);
    },
    addMember() {
      const profile = {
        firstName: this.data.newMember.firstName,
        lastName: this.data.newMember.lastName,
        dob: parseBirthdate(this.data.newMember.birthdate),
        gender: this.data.newMember.gender,
      };
      this.$store.commit('loading', { loading: true, text: 'Loading...' });
      this.$http.post('/assemble/api/v1/account/portal/members-no-link', {
        profile
      }).then((response) => {
        // emit member to parent
        const member = {
          _id: response.data.data,
          profile
        };
        this.$emit('selectMember', member);
        this.$message({ message: 'Member added successfully', type: 'success' });
        this.$store.commit('loading', false);
      }).catch((e) => {
        this.$message.error(e.response.data.message);
        this.$store.commit('loading', false);
      });
    },
    formatBirthdate(val) {
      return parseBirthdate(val, true);
    },
    get: _.get,
  }
};
</script>

<style lang="scss" scoped>
.card-container {
  width: 100%;
  max-width: $md;

  .el-col {
    margin-bottom: 1.5em;
  }

  .member-card {
    padding: 1em;
    min-height: 15em;

    ::v-deep .el-card__body {
      padding: 0.5em;
      display: flex;
      flex-direction: column;
      flex: 1 1 auto;
    }

    .member-avatar {
      width: 5.5em;
      margin-top: -1em;
    }

    .member-info {
      .name {
        font-size: 1.5em;
        flex: 0 0 auto;
      }

      .description {
        padding-top: 0.5em;
        padding-bottom: 0.5em;
        font-size: 0.8em;
        flex: 1 1 auto;
      }
    }

    .member-btn {
      padding-top: 1em;
      border-top: 1px solid rgba(45, 58, 69, 0.1);
    }
  }

  .member-add {
    padding: 1em;
    height: 15em;
    border-color: rgba($highlight, 0.5);

    ::v-deep .el-card__body {
      padding: 0.5em;
      display: flex;
      flex-direction: column;
      justify-content: center;
      align-items: center;
      height: 100%;
    }
  }
}
</style>
